import * as React from 'react';
const DEFAULT_THRESHOLD = 0;
const useScrollDirection = (threshold = DEFAULT_THRESHOLD) => {
    const [scrollDirection, setScrollDirection] = React.useState('up');
    const blocking = React.useRef(false);
    const prevScrollY = React.useRef(0);
    React.useEffect(() => {
        prevScrollY.current = window.pageYOffset;
        const updateScrollDirection = () => {
            const scrollY = window.pageYOffset;
            const scrollDifference = Math.abs(scrollY - prevScrollY.current);
            if (scrollDifference >= threshold) {
                const newScrollDirection = scrollY > prevScrollY.current ? 'down' : 'up';
                setScrollDirection(newScrollDirection);
                prevScrollY.current = scrollY > 0 ? scrollY : 0;
            }
            blocking.current = false;
        };
        const onScroll = () => {
            if (!blocking.current) {
                blocking.current = true;
                window.requestAnimationFrame(updateScrollDirection);
            }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, [threshold]);
    return scrollDirection;
};
export { useScrollDirection };
